import { refreshTokenApi } from "../services/auth/authService";
import type { LoginResponse } from "../models/auth/AuthModels";

export const getToken = (): string | null => {
  return localStorage.getItem("token");
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem("refreshToken");
};

export const saveTokens = (token: string, refreshToken: string) => {
  localStorage.setItem("token", token);
  localStorage.setItem("refreshToken", refreshToken);
};

export const clearTokens = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
};

export const refreshToken = async (): Promise<string | null> => {
  const token = getToken();
  const refresh = getRefreshToken();

  if (!token || !refresh) return null;

  const response: LoginResponse = await refreshTokenApi(token, refresh);

  if (response.flag && response.token && response.refreshToken) {
    saveTokens(response.token, response.refreshToken);
    return response.token;
  }

  clearTokens();
  return null;
};